/*
MobileDropdownMenu.js
移动端头部下拉菜单
 */

import React, {useEffect, useState} from 'react';
import {Button, Col, Dropdown, Form, Input, message, Modal, Row, Space} from "antd";
import {SettingFilled} from "@ant-design/icons";

import {dropdown_items} from "./dropdown_items";
import {ACTIVE_SESSION_DEFAULT_VALUE, ACTIVE_SESSION_KEY} from "../../../Common/constants";
import {
    updateSessionTitle,
    getSessionTitle,
    deleteSession,
    getAllSessions,
    saveSession
} from "../../../Model/IndexedDB";
import {createNewSession} from "../../../Model/Session/createNewSession";

const {TextArea} = Input;

const MobileDropdownMenu = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [oldSessionTitle, setOldSessionTitle] = useState('');

    const [form] = Form.useForm();

    // 当modal打开的时候，这个时候form也加载完了，进行就title的设置，保证及时更新
    useEffect(() => {
        if (isModalOpen === true) {
            form.setFieldsValue({
                old_title: oldSessionTitle,
            });
        }
    }, [isModalOpen]);

    // dropdown下来菜单items的点击事件
    const onClick = ({key}) => {
        const sessionID = sessionStorage.getItem(ACTIVE_SESSION_KEY);
        // 排除会话ID错误的情况
        if (sessionID === ACTIVE_SESSION_DEFAULT_VALUE) {
            return;
        }
        switch (key) {
            // 重命名
            case '1':
                handleGetSessionTitle({sessionID: sessionID}).then(() => {
                    setIsModalOpen(true);
                });
                break;
            // 删除
            case '2':
                handleDeleteSession(sessionID).then(() => {
                    message.success('删除成功').then();
                    const activeSessionID = sessionStorage.getItem(ACTIVE_SESSION_KEY);
                    getAllSessions().then((sessions) => {
                        if (sessions.length > 0) {
                            // 删除的时候删除的id与当前激活的是一个的时候，就把第一个激活
                            if (sessionID === activeSessionID) {
                                sessionStorage.setItem(ACTIVE_SESSION_KEY, sessions[0].sessionID);
                            }
                        } else {
                            const newSession = createNewSession();
                            saveSession(newSession).then(() => {
                                sessionStorage.setItem(ACTIVE_SESSION_KEY, newSession.sessionID);
                            });
                        }
                    });
                });
                break;
        }
    };

    // 更新会话的title
    const handleUpdateSessionTitle = async ({sessionID, newTitle}) => {
        await updateSessionTitle(sessionID, newTitle);
    };

    // 获取当前活动会话的标题title
    const handleGetSessionTitle = async ({sessionID}) => {
        const title = await getSessionTitle(sessionID);
        setOldSessionTitle(title);
    }

    // 重命名form提交按钮
    const formCommit = (value) => {
        const sessionID = sessionStorage.getItem(ACTIVE_SESSION_KEY);
        // 排除会话ID错误的情况
        if (sessionID === ACTIVE_SESSION_DEFAULT_VALUE) {
            return false;
        }
        handleUpdateSessionTitle({sessionID: sessionID, newTitle: value.new_title}).then(() => {
            // 关闭模态框
            setIsModalOpen(false);
            // 重置表单
            form.resetFields();
            return true;
        });
    };

    // 删除会话
    const handleDeleteSession = async (sessionId) => {
        await deleteSession(sessionId);
    };

    // 取消按钮点击
    const cancelBtnClicked = () => {
        // 重置表单
        form.resetFields();
        setIsModalOpen(false);
    };

    return (
        <div>
            <Dropdown menu={{items: dropdown_items, onClick: onClick}}>
                <Button type='text' icon={<SettingFilled style={{color: '#808080'}}/>} size='large'/>
            </Dropdown>
            <Modal title="添加" open={isModalOpen} footer={null} closable={false}>
                <Row justify='center' style={{marginTop: 20}}>
                    <Col span={23}>
                        <Form name='rename' form={form} layout='vertical' onFinish={formCommit}>
                            <Form.Item name='old_title' label='旧名称:'>
                                <TextArea disabled autoSize variant="borderless" style={{color: '#000'}}/>
                            </Form.Item>
                            <Form.Item name='new_title' label='新名称:'
                                       rules={[{required: true, message: '请输入新名称!'},]}>
                                <TextArea placeholder='输入新名称' showCount maxLength='20'
                                          allowClear autoSize/>
                            </Form.Item>
                            <Form.Item style={{textAlign: 'right'}}>
                                <div style={{height: 20}}></div>
                                <Space size='middle'>
                                    <Button onClick={cancelBtnClicked}>取消</Button>
                                    <Button type='primary' htmlType='submit'>确定</Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Modal>
        </div>
    );
};

export default MobileDropdownMenu;
